<template>
    <transition name="order-modal">
        <div class="tingle-modal order-modal-mask order-loading-modal">
            <div
                class="tingle-modal-box order-modal-wrapper"
            >
                <div class="tingle-modal-box__content order-modal-container">
                    <div class="order-loading-modal__logo">
                        <img
                            src="../../../images/branding/logo.svg"
                            alt="Öpfelchasper"
                        >
                    </div>
                    <h3 class="order-loading-modal__heading">{{ text }}</h3>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line

export default {
    props: {
        text: {
            type: String,
            default: 'Dein Korb wird zusammengestellt',
        },
    },
    created() {
        $('html').addClass('scrolling-disabled');
    },
    destroyed() {
        $('html').removeClass('scrolling-disabled');
    },
};
</script>




// WEBPACK FOOTER //
// Loading.vue?02adf96b